import AppRouter from 'common/AppRouter';
import { WhiteSection } from 'components/base/layout-components';
import AddTeam from './Teams/TeamsConfig/AddTeam';
import AddGroup from './Teams/TeamsConfig/AddGroup';
import EditTeam from './Teams/TeamsConfig/EditTeam';
import ContributorsAndTeamsSettings from './ContributorsAndTeamsSettings';
import LicenseBar from './LicenseBar';
import { Routes, Route } from 'react-router-dom-v5-compat';

function ContributorsAndTeamsRouter() {
  return (
    <WhiteSection>
      <div className='mt-4'>
        <LicenseBar />

        <Routes>
          <Route
            path={AppRouter.TEAMS_SETTINGS_ADD.path}
            element={<AddTeam />}
          />
          <Route
            path={AppRouter.GROUPS_SETTINGS_ADD.path}
            element={<AddGroup />}
          />
          <Route
            path={AppRouter.TEAMS_SETTINGS_EDIT.path}
            element={<EditTeam />}
          />
          <Route path='*' element={<ContributorsAndTeamsSettings />} />
        </Routes>
      </div>
    </WhiteSection>
  );
}

export default ContributorsAndTeamsRouter;
